<template>
  <v-row class="justify-center py-12">
    <v-card
      :width="$vuetify.display.mobile ? `100%` : `50%`"
      :max-width="$vuetify.display.mobile ? `100%` : `50%`"
    >
      <v-window v-model="tab">
        <v-window-item value="one">
          <v-card-title class="mt-4">Új jelszó</v-card-title>
          <v-card-actions style="padding: 1rem">
            <v-row class="justify-space-between align-center">
              <v-col cols="12">
                <v-text-field
                  type="password"
                  label="Jelszó"
                  variant="underlined"
                  :rules="pwRules"
                  v-model="pw1"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  type="password"
                  label="Jelszó újra"
                  variant="underlined"
                  :rules="matchPw"
                  v-model="pw2"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  size="large"
                  class="w-100"
                  variant="outlined"
                  @click="sendreset"
                  :disabled="shouldDisable"
                >
                  <span class="ml-4">Új jelszó beállítása</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-window-item>
      </v-window>
    </v-card>
  </v-row>

  <SaveDialog :showdialog="isSaveDialogVisible" :text="message" okayText="Rendben" @dialogChange="handleDialogChange"/>
</template>

<script>
import { defineComponent } from 'vue'
import { newPw } from '../services/userServices'
import SaveDialog from '../components/SaveDialog.vue'
import { RszValidators } from '../modules/rszValidators'


export default defineComponent({
  name: 'ResetPassword',
  components: {
    SaveDialog,
  },
  data() {
    return {
      pw1: null,
      pw2: null,
      tab: null,
      isSaveDialogVisible: false,
      shouldDisable: true,
      message: null,
      pwRules: [
        (value) => {
          if (!value) return false
          if (RszValidators.passwordPattern.test(value)) {
            this.shouldDisable = false
            return true
          }
          this.shouldDisable = true
          return `A legalább 8 karakter hosszú jelszó kell, hogy tartalmazzon kis- és nagybetűt, valamint számot!`
        },
      ],
      matchPw: [
        (value) => {
          if (value == this.pw1) {
            return true
          }
          return 'A megadott jelszavak nem egyeznek meg'
        }
      ]
    }
  },
  methods: {
    async sendreset() {
      this.message = (await newPw(this.$route.params.token, this.pw1))?.message
      this.isSaveDialogVisible = true
    },
    async handleDialogChange() {
      await this.$router.push({name: 'home'})
    },
  },
})
</script>

<style scoped>
p {
  margin-top: 1rem;
  text-align: justify;
}
</style>
